export const convertBranchQuery = (data) => {
  return data?.map((item) => ({
    value: item?.id,
    label: item?.name,
  }));
};
